(function () {
  function handleSubmit(event) {
    event.preventDefault();

    var form = event.target;
    var endpoint = form.dataset.endpoint;
    var status = form.querySelector('[data-review-status]');
    var submitButton = form.querySelector('button[type="submit"]');

    if (!endpoint) {
      status.textContent = 'El formulario de reseñas no está configurado todavía.';
      status.dataset.state = 'error';
      return;
    }

    var formData = new FormData(form);
    var payload = {
      productId: Number(form.dataset.productId),
      rating: Number(formData.get('rating')),
      authorName: formData.get('authorName'),
      email: formData.get('email'),
      title: formData.get('title'),
      body: formData.get('body'),
      website: formData.get('website'),
    };

    submitButton.disabled = true;
    status.dataset.state = '';
    status.textContent = 'Enviando...';

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok && data.ok, data: data };
        });
      })
      .then(function (result) {
        if (result.ok) {
          status.dataset.state = 'success';
          status.textContent = '¡Gracias! Tu reseña se publicará luego de ser revisada.';
          form.reset();
        } else {
          status.dataset.state = 'error';
          status.textContent = 'No pudimos enviar tu reseña. Revisá los datos e intentá de nuevo.';
        }
      })
      .catch(function () {
        status.dataset.state = 'error';
        status.textContent = 'No pudimos enviar tu reseña. Intentá de nuevo más tarde.';
      })
      .finally(function () {
        submitButton.disabled = false;
      });
  }

  document.querySelectorAll('[data-review-form]').forEach(function (form) {
    form.addEventListener('submit', handleSubmit);
  });
})();
